import React from 'react';

const SettingsSection = ({ title, subtitle, children, className = '' }) => {
  return (
    <div className={`rounded-xl border-2 border-gray-200 shadow-sm overflow-hidden ${className}`}>
      {title && (
        <div className="px-4 py-3 border-b-2 border-gray-200 bg-gray-50/50">
          <h3 className="font-bold text-lg text-gray-900 tracking-tight">{title}</h3>
          {subtitle && <p className="text-xs text-gray-500 font-medium mt-1">{subtitle}</p>}
        </div>
      )}
      <div className="px-2 divide-y-2 divide-gray-50">{children}</div>
    </div>
  );
};

export default SettingsSection;